import { useCookies } from 'react-cookie';
import React, { useEffect, useState } from 'react';
import API from '../services/ApiService';
import LoginForm from './LoginForm';
import { useAuth } from '../context/AuthContext';
import GhostIcon from './GhostIcon';
import CameraIcon from './CameraIcon';
import HomeIcon from './HomeIcon';
import { NavLink, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import ErrorBoundary from './ErrorBoundary/ErrorBoundary';
import { GoPersonFill } from "react-icons/go";


export default function LoginBar(){
    const [cookies, setCookie, removeCookie] = useCookies(['user']);
    const [loginModalOpen, setLoginModalOpen] = useState(false);
    const { contextUser, isLoggedIn, contextLogin, contextLogout } = useAuth();
    const navigate = useNavigate();

    async function refreshSession(){
        try{
            const res = await API.refreshToken();
            if (res.status === 200){
                const { username, isLoggedIn } = cookies.user;
                setCookie('user',
                    JSON.stringify({
                        username: username,
                        isLoggedIn: isLoggedIn
                    }),
                    {
                        path: "/",
                        maxAge: 60 * 60 * 24 * 7
                    });
                contextLogin({username: username,
                            isLoggedIn: isLoggedIn
                            });
            } else {
                if (localStorage.getItem("hasEverHadSession")) {
                    toast.error("Session refresh failed, logging out. Please log in again or continue as guest.");
                    removeCookie('user', {path: '/'});
                    contextLogout();
                }
            }
        } catch(err) {
            if (!err.response) {
                toast.error("Unexpected error during token refresh");
            }
        }
    }

    async function logout(){
        try {
            const res = await API.logout();
            if (res.status === 200){
                removeCookie('user', {path: '/'});
                contextLogout();
                loginAnonymous();
            } else {
                toast.error("Error during logout");
            }
        } catch(err)  {
            toast.error("Unexpected error during logout");
        }
    }

    async function loginAnonymous(){
        try {
            const res = await API.createGuest();
            if (res.status === 200){
                setCookie('user',
                    JSON.stringify({
                        username: null,
                        isLoggedIn: false
                    }),
                    {
                        path: "/",
                        maxAge: 60 * 60 * 24 * 7
                    });
                contextLogin({username: null,
                            isLoggedIn: false
                            });
            }
        } catch(err) {
            toast.error("Could not create guest session");
        }
    }
    function openLoginModal(){
        setLoginModalOpen(true);
    }

    useEffect(() => {
        if (cookies.user){
            refreshSession();
        } else {
            loginAnonymous();
        }
    }, []);
    return(
        <div className="login-bar">
            <h1 className="login-bar-logo" onClick={() => navigate('/')}>
                <span>Phasmo</span><span className='neon-red'>dle</span>
            </h1>
            <div className="login-bar-nav">
                <NavLink 
                    className={({ isActive }) => 
                        `nav-item item-1 ${isActive ? "active" : ""}`
                    } 
                    to="/">
                    <HomeIcon classes="nav-svg-icon"/><span className="nav-item">Main Page</span>
                </NavLink>
                <NavLink 
                    className={({ isActive }) => 
                        `nav-item item-2 ${isActive ? "active" : ""}`
                    }  
                    to="/ghost">
                    <GhostIcon classes="nav-svg-icon"/><span className="nav-item">Ghost Hunting</span>
                </NavLink>
                <NavLink 
                    className={({ isActive }) => 
                        `nav-item item-3 ${isActive ? "active" : ""}`
                    } 
                    to="/room">
                    <CameraIcon classes="nav-svg-icon"/><span className="nav-item">Room Guesser</span>
                </NavLink>
            </div>
            <div>{isLoggedIn && contextUser?.isLoggedIn ? 
                <React.Fragment>
                    <GoPersonFill className='profile-icon' title="Profile page coming soon!"/>
                    <span className='login-text'>Welcome, {cookies.user.username}! <button className="login-bar-logout" onClick={logout}>Log out</button></span>
                    <button className="login-bar-logout mobile-only" onClick={logout}>Log out</button>
                </React.Fragment>
                : 
                <React.Fragment>
                    <span className='login-text'><button className="login-bar-login" onClick={openLoginModal}>Log in</button> to save your results.</span>
                    <button className="login-bar-login mobile-only" onClick={openLoginModal}>Log in</button>
                </React.Fragment>}
           </div>
            <ErrorBoundary>
                {loginModalOpen && <LoginForm setLoginModalOpen={setLoginModalOpen} />}
            </ErrorBoundary>
        </div>
    )
}